import React, { useCallback, useState, useContext } from "react";
import { NavLink } from "react-router-dom";

import VehicleRoutesList from "../components/vehicle-routes/VehicleRoutesList";
import VehicleRouteItem from "../components/vehicle-routes/VehicleRouteItem";
import ErrorModal from "shared/components/UIElements/ErrorModal";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "shared/hooks/http-hook";
import { StoreContext } from "shared/context/store-context";
import "./Admin.css";

const VehicleRoutes = () => {
  const store = useContext(StoreContext);
  const { isLoading, error, clearError } = useHttpClient();
  const [selectedItemId, setSelectedItemId] = useState();
  const [selectedItemShow, setSelectedItemShow] = useState(false);

  const pageItems = store.vehicleRoutes;
  const newItemLink = "/new/vehicleroute";
  const ItemTypeTR = "Servis";

  const ItemSelectHandler = useCallback((itemid) => {
    setSelectedItemId(itemid);
    setSelectedItemShow(true);
  }, []);

  const ItemUpdateHandler = useCallback((itemid) => {
    setSelectedItemId(itemid);
  }, []);

  if (isLoading || !store.vehicleRoutes) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <div className="adminNavigationHeader">
        <NavLink to={newItemLink} exact>
          Yeni {ItemTypeTR}
        </NavLink>
      </div>
      <div className="adminpageContainer">
        {!isLoading && pageItems && (
          <div className="adminListContainer">
            <VehicleRoutesList
              items={pageItems.filter((vehicleRoute) => vehicleRoute.routelocations.length === 0)}
              onItemSelect={ItemSelectHandler}
            />
          </div>
        )}
        {selectedItemId && selectedItemShow && (
          <div className="adminUpdateContainer">
            <VehicleRouteItem
              itemid={selectedItemId}
              onItemUpdate={ItemUpdateHandler}
              onClose={() => setSelectedItemShow(false)}
            ></VehicleRouteItem>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default VehicleRoutes;
